import AjaxHandler from "./ajax-handler";
import "select2";

class ResistanceTable {
	constructor() {
		this.$ = jQuery;
		this.ajax = new AjaxHandler();
		this.form = $('form[name="filter-resistance-table"]');

		this.filterParams = new URLSearchParams(window.location.search);

		this.filterSelects = $(
			".resistance-filter select.filter-select"
		);

		if (this.filterSelects.length) {
			this.initFilters();
		}
	}

	updateMaterialsResultCount() {
		const itemsSelectedText =
			$('.resistance-filter input[name="itemsSelectedText"]').val() ?? " selected materials";

		var uldiv = $('.filter-materials').siblings('span.select2').find('ul')
		var count = $('.filter-materials').select2('data').length

		if (count == 0) {
			uldiv.html("")
		} else {
			uldiv.html("<li class=\"ticker\">" + count + " " + itemsSelectedText + "</li>")
		}
	}

	drawSelect2() {
		var self = this;

		let itemsSelected = $('')
		const chooseFilterText =
			$('.resistance-filter input[name="chooseFilterText"]').val() ?? "Välj filter";

		const selectMaterialText =
			$('.resistance-filter input[name="selectMaterialText"]').val() ?? "Välj filter";

		if (!this.filterSelects.length)
			return false;

		var $select_chemicals = $('.filter-select.filter-chemicals');
		var $select_materials = $('.filter-select.filter-materials');

		// Custom matcher to search both translated name and original English name
		function customMatcher(params, data) {
			// If there are no search terms, return all data
			if ($.trim(params.term) === '') {
				return data;
			}

			// Do not display the item if there is no 'text' property
			if (typeof data.text === 'undefined') {
				return null;
			}

			// Search in the displayed text (translated name)
			var searchTerm = params.term.toLowerCase();
			var translatedName = data.text.toLowerCase();

			// Get original English name from data attribute
			var originalName = '';
			if (data.element && $(data.element).data('original-name')) {
				originalName = $(data.element).data('original-name').toLowerCase();
			}

			// Check if search term matches translated name or original English name
			if (translatedName.indexOf(searchTerm) > -1 || originalName.indexOf(searchTerm) > -1) {
				return data;
			}

			// Return `null` if the term should not be displayed
			return null;
		}

		$select_chemicals.select2({
			dropdownParent: $select_chemicals.closest(".filter-select-container"),
			// closeOnSelect: false,
			placeholder: chooseFilterText,
			allowHtml: true,
			allowClear: true,
			templateResult: ucResultsTemplate,
			templateSelection: ucSelectTemplate,
			matcher: customMatcher,
		})
			.on("select2-open", function () {
				$(this).select2('positionDropdown', true);
			})
			.on('select2:select', function (evt) {
				self.form.trigger("submit");
			});

		$select_chemicals.one('select2:open', function (e) {
			$('input.select2-search__field').prop('placeholder', selectMaterialText);
		});

		function ucSelectTemplate(vars) {
			var data = vars.text.split(';');

			if (data.length <= 0) {
				return vars;
			}

			return data[0] ?? '';
		}

		function ucResultsTemplate(vars) {
			var data = vars.text.split(';');

			if (data.length <= 0) {
				return vars;
			}

			var name = data[0] ?? '';
			var cas = data.length >= 1 && data[1] ? '( ' + (data[1] ?? '') + ' )' : '';

			var $html = $('<span class="cas-row align-items-center d-inline-flex"><span class="mw-70">' + name + '</span> <span class="cas-nr ml-auto text-gray-2 fs-12">' + cas + '</span></span>');

			return $html;
		};

		$select_materials.select2({
			dropdownParent: $select_materials.closest(".filter-select-container"),
			closeOnSelect: false,
			placeholder: '',
			allowHtml: true,
			allowClear: true,
			tags: false
		})
			.on("select2-open", function () {
				$(this).select2('positionDropdown', true);
			})
			.on('select2:unselect', function (evt) {
				self.updateMaterialsResultCount()
				toggleVisibleMaterials($('.filter-materials').select2('data'));;
			})
			.on('select2:select', function (evt) {
				self.updateMaterialsResultCount()
				toggleVisibleMaterials($('.filter-materials').select2('data'));;
			})
			.on('select2:close', function (evt) {
				self.updateMaterialsResultCount('.filter-materials')
			});

		// Add counts
		self.updateMaterialsResultCount();

		function toggleVisibleMaterials(list) {
			$('.resistance-filter .material-container .material-box').each(function () {
				var material = $(this).data('material');

				if (material) {
					if (!list.find(o => o.text === material.toUpperCase())) {
						$(this).fadeOut();
					} else {
						$(this).fadeIn();
					}
				}
			});
		}
	}

	initFilters() {
		var self = this;

		this.drawSelect2();

		this.filterSelects.on("change", function (e) {
			let $removeFilter = $(this)
				.parents(".filter-block")
				.find(".remove-filter");
			var selected = $(this)
				.parents(".filter-block")
				.find(":selected");

			if (selected.length >= 1) {
				$removeFilter.css("visibility", "visible");
			} else {
				$removeFilter.css("visibility", "hidden");
			}
		});

		// Submit form
		self.form.on("submit", function (e) {
			e.preventDefault();

			var $p = $('.filter-chemicals').find(':selected');

			if (!$p.data('id'))
				return false;

			var formData = {
				chemical_id: $p.data('id')
			};

			self.queryFilter(formData);
		});

		self.form.trigger("submit");
	}

	queryFilter(formData) {
		var self = this;

		let postVars = {
			action: "filter_resistance_table",
			nonce: ajax.nonce,
			chemical_id: formData.chemical_id
		};

		var $filterContainer = $(".block-resistance-table .filter-selects");
		var $resultsContainer = $(".block-resistance-table .material-container");

		if ($filterContainer.attr("data-requestRunning") == "true") return;

		$filterContainer.attr("data-requestRunning", true).css('opacity', '.5').css('pointer-events', 'none');

		$resultsContainer.LoadingOverlay("show", {
			imageClass: "jquery-loading-overlay-icon",
			image: ajax.templateUrl + "/assets/svg/flask-loading.svg",
			imageResizeFactor: 1,
			zIndex: 800,
			imageAnimation: "1500ms pulse",
			background: "rgba(255, 255, 255, 0.5)"
		});

		$(".block-resistance-table .filter-selects select.filter-select").select2("close");

		$.ajax({
			beforeSend: xhr => {
				xhr.setRequestHeader("X-WP-Nonce", ajax.nonce);
			},
			url: ajax.url,
			method: "POST",
			data: postVars,
			dataType: "json"
		}).done(response => {
			var html = "";
			$resultsContainer.find("span").text(0);

			// Close select2 dropdown on desktop
			$(".block-resistance-table .filter-selects select.filter-select").select2("close");

			if (response.result) {
				html += response.result;
				//$resultsContainer.find("span").text(response.count);
			} else {
				html =
					'<div class="no-results w-50 m-auto text-center">' +
					response.no_results +
					"</div>";
			}

			$resultsContainer.LoadingOverlay("hide").html(html);

			self.updateMaterialsResultCount();

			$filterContainer
				.attr("data-requestRunning", false)
				.css('opacity', '1').css('pointer-events', 'all');

			$('[data-toggle="tooltip"]').tooltip()
		});
	}
}

export default ResistanceTable;
